module.exports = __webpack_public_path__ + "static/img/group-3@3x.9c4a12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduction/group-3@3x.png
// module id = PkTi
// module chunks = 6